module.exports = __webpack_public_path__ + "static/nicole-profile.752c24d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nicole-profile.jpg
// module id = 465
// module chunks = 35783957827783